import React, { useEffect, useState } from "react";
import Button from "../modules/Button";
import MultiSelect from "../modules/MultiSelect";
import DropBtn from "../modules/DropBtn";
import avatar from "../../Assets/svg/avatar-img.svg";
import down from "../../Assets/svg/down arrow new.svg";
import RequestListView from "./RequestListView";
import { useSelector, useDispatch } from "react-redux";
import { api } from "../../Services";
import { addMentorInfo, resetClear } from "../Connect/redux/actions";
import { GetLogout } from "../modules/Logout";
import { resetState } from "../PersonalInfo/redux/actions";
import { resetIncome } from "../IncomeDetails/redux/actions";
import { resetEdu } from "../Education/redux/actions";
import { resetRegister } from "../Register/redux/actions";
import { resetApp } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { clearDisburse } from "../DisburseForm/redux/actions";
import { doLogout } from "../LoginPage/redux/actions";

function Requests() {
  const dispatch = useDispatch();
  const tokenData = useSelector((state) => state.tokens.tokens);
  const alumni = useSelector((state) => state.connect.alumniRequests);
  const personalInfo = useSelector((state) => state.personal.personalInfo);

  const [ModalData, setModalData] = useState({
    show: false,
    type: "confirm",
    title: "",
    countDown: " ",
    desc: "",
  });
  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log('logout api', users)
      // if (users.statusCode == 200) {
        dispatch(resetState());
        dispatch(resetIncome());
        dispatch(resetEdu());
        dispatch(resetRegister());
        dispatch(resetApp());
        dispatch(resetQueries());
        dispatch(resetStatus());
        dispatch(clearDisburse());
        dispatch(resetClear());
        dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };
  const logoutMsg = async () => {
    let users = await getLogout();
    console.log("logout api", users);
    console.log("u have been logged out");
  };
  const getAlumni = async () => {
    try {
      const alumniData = await api.getRequests(
        tokenData.token,
        true,
        tokenData.applicationData.id
      );
      if (alumniData.statusCode == 200) {
        dispatch(
          addMentorInfo({
            type: "alumniRequests",
            value: alumniData.data ? [...alumniData.data] : [],
          })
        );
        // }else{
        //   dispatch(addMentorInfo({type:"alumniRequests", value:[]}));
      } else if (alumniData.data.includes("Session expired")) {
        logoutMsg();
      }
      // if (mentorData.data) {
      //   dispatch(addMentorInfo([...mentorData.data]));
      // }
    } catch (err) {
      console.log("err", err);
      if (err?.statusCode !== 200 && err?.data?.includes("Session expired")) {
        logoutMsg();
      }
    }
  };

  useEffect(() => {
    getAlumni();
  }, []);
  console.log("alumni requests", alumni);

  return (
    <div className="request-page">
      {alumni?.map((item, index) => {
        return (
          <RequestListView
            getAlumni={() => getAlumni()}
            item={item}
            key={index}
          />
        );
      })}
    </div>
  );
}

export default Requests;
